import type { UserAccessConfigDto, UserAccessOverrideDto } from '../dto';
import type { UserAccessConfig, UserAccessOverride } from '../models';

export const mapUserAccessOverrideDtoToModel = (
  dto: UserAccessOverrideDto,
): UserAccessOverride => ({ ...dto });

export const mapUserAccessOverridesListDtoToModel = (
  dtos: UserAccessOverrideDto[],
): UserAccessOverride[] => dtos.map(mapUserAccessOverrideDtoToModel);

export const mapUserAccessConfigDtoToModel = (
  dto: UserAccessConfigDto,
): UserAccessConfig => ({
  ...dto,
  data: mapUserAccessOverridesListDtoToModel(dto.data),
});

export const mapUserAccessConfigModelToDto = (
  config: UserAccessConfig,
): UserAccessConfigDto => ({
  data: config.data.map((override) => ({ ...override })),
});
